export default "__VITE_ASSET__f8OVrQ$mjlwMx9kvqjUDuQ__"